export default "__VITE_ASSET__ed869ddf__"